export const VERIFICATION_STATUS = {
  START: 'start',
  PENDING: 'pending',
  SUMSUB_PENDING: 'sumsub_pending',
  SUMSUB_COMPLETED: 'sumsub_completed',
  COMPLIANCE_CHECK: 'compliance_check',
  REJECTED: 'rejected',
  CORPORATE_SUCCESS: 'corporate_success',
} as const;

export type VerificationStatus =
  (typeof VERIFICATION_STATUS)[keyof typeof VERIFICATION_STATUS];
